import React from "react";
import { useQuickSightCosts } from "@/hooks/useMonthlyCostsReports";
import AWSReportsTemplate from "@/components/templates/AWSReportsTemplate";
import QuickSightAwsCostsDashboard from "@/components/organisms/MonthlyCostsDashboard";

function MonthlyCostsReports() {
  const { embedUrl, loading, error, refetch } = useQuickSightCosts();

  return (
    <AWSReportsTemplate
      title="AWS Costs Dashboard"
      loading={loading}
      error={error}
      onRetry={refetch}
      hideFilters={true}
      hideDownload={true}
    >
      <QuickSightAwsCostsDashboard />
    </AWSReportsTemplate>
  );
}

export default MonthlyCostsReports;
